import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.material.blue.light.compact.css';
import '@botto/core/theme';

import { createApp } from 'vue';
import { createPinia } from 'pinia';
import dxConfig from 'devextreme/core/config';
import { registerModule, env, configureAuthRedirect, type ModuleManifest } from '@botto/core';
import trackerModule from '@botto/module-tracker';
import smsModule from '@botto/module-sms';
import tariffsModule from '@botto/module-tariffs';
import cdpModule from '@botto/module-cdp';

import App from './App.vue';
import { notFoundRoute, router } from './router';
import { menuStore } from './layout/menu';

dxConfig({
  ...(env.devextremeLicenseKey ? { licenseKey: env.devextremeLicenseKey } : {}),
});

if (!env.devextremeLicenseKey && env.isDev) {
  console.warn('[botto] VITE_DEVEXTREME_LICENSE_KEY is empty — DevExtreme will run in trial mode');
}

const app = createApp(App);
const pinia = createPinia();

app.use(pinia);

configureAuthRedirect(async (redirect) => {
  await router.replace({ name: 'login', query: { redirect } });
});

const modules: ModuleManifest[] = [smsModule, tariffsModule, cdpModule, trackerModule];

// Register module routes before installing the router so deep links
// (e.g. /sms/routing-choices/220) match on reload instead of the 404 catch-all.
await Promise.all(modules.map((m) => registerModule({ app, router }, m)));
// Menu order must follow `modules`, not Promise.all completion order.
for (const m of modules) {
  menuStore.registerSection(m.menu);
}
router.addRoute(notFoundRoute);

app.use(router);
await router.isReady();
app.mount('#app');
